import React, { useState, useEffect } from 'react';
import Button from '@material-ui/core/Button';
import { approveRejectPatientRegistration, getAllHCPList } from '../../services/user.service';
import { FormControl, FormLabel, makeStyles, TextField, Typography, Select, MenuItem } from '@material-ui/core';
import Dialog from '../ui/Dialog';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getProductBrandList } from '../../services/product.service';

const PatientRegistrationApprovalWithTier = ({ data }) => {
    const { patient_id, status, program_id, child_program_id, financial_assessment, dosage } = data;
    const [openModal, setOpenModal] = useState(false);
    const [openConfirmation, setConfirmation] = useState(false);
    const [openConfirmTier, setOpenConfirmTier] = useState(false);
    const [modalTitle, setModalTitle] = useState("Approval / Rejection of Patient Registration");
    const [successMessage, setSuccessMessage] = useState('');
    const [rejectionNotes, setRejectionNotes] = useState(""); 
    const [selectedTier, setSelectedTier] = useState<string>("tier2");   
    const [hcpList, sethcpList] = useState([]);
    const [selectedDoctor, setSelectedDoctor] = useState<any>(null);
    const [selectedHospital, setSelectedHospital] = useState(null); 

    const [selectedIp, setSelectedIp] = useState<string>("");
    const [selectedMp, setSelectedMp] = useState<string>("");
    const [initialOptions, setInitialOptions] = useState<any[]>([]);
    const [maintenanceOptions, setMaintenanceOptions] = useState<any[]>([]);
     const [filteredMaintenanceOptions, setFilteredMaintenanceOptions] = useState<any[]>([]);
    
    const [allSchemes, setAllSchemes] = useState<any[]>([]);
    const [selectedScheme, setSelectedScheme] = useState<any>(null);


    const useStyles = makeStyles(() => ({
        field: {
            marginBottom: 20,
        },
        formControl: {
            width: '250px',
            height: '250px',
            marginTop: '10px',
            marginBottom: '20px',
        }
    }));

    const classes = useStyles();

    useEffect(() => {
        const getHCPs = async () => {
          const { result } = await getAllHCPList({ program_id });    
          sethcpList(result);
        }    
        getHCPs();    
      }, []);

    useEffect(() => {
        const getSchemes = async () => {
            if (child_program_id?.includes('soliris')) {
                const schemes = await getProductBrandList(child_program_id);
            //console.log("schemes", schemes);

            // 1 Extract all schemes from brands
            const allSchemes = schemes.flatMap(
                (brand: any) => brand?.brand_metadata?.schemes || []
            );
            setAllSchemes(allSchemes);
            // 2️ Separate initial & maintenance
            const initialPhase = allSchemes.filter((scheme: any) =>
                scheme.scheme_id?.includes('initial_phase')
            );

            const maintenancePhase = allSchemes.filter((scheme: any) =>
                scheme.scheme_id?.includes('maintenance_phase')
            );

            // 3️ Convert to dropdown format
            const formattedInitial = initialPhase.map((scheme: any) => ({
                label: scheme.scheme_label,
                value: scheme.scheme_id,
            }));

            const formattedMaintenance = maintenancePhase.map((scheme: any) => ({
                label: scheme.scheme_label,
                value: scheme.scheme_id,
                group_id: scheme.group_id,
            }));

            setInitialOptions(formattedInitial);
            setMaintenanceOptions(formattedMaintenance);

            // 4️ Set default selected values
            setSelectedIp(formattedInitial[0]?.value || "");
            setSelectedMp(formattedMaintenance[0]?.value || "");
            }

            if (child_program_id?.includes('truqap')) {
                  const schemes = await getProductBrandList(child_program_id);
                    //console.log("truqap - schemes", schemes);
                    //console.log("truqap - dosage", dosage);

                const allSchemes = schemes.flatMap((b: any) => b?.brand_metadata?.schemes || []);

                const matchedScheme =
                    (dosage && allSchemes.find((s: any) => s.purchase_sku_id === dosage)) ||
                    allSchemes.find((s: any) => s.default === true);
                    //console.log("matchedScheme", matchedScheme);
                    setSelectedScheme(matchedScheme);   

            }
        }
        getSchemes();
    }, [child_program_id]);  

    useEffect(() => {
        if (selectedIp && allSchemes.length) {
            setSelectedMp("");
            const selectedInitialScheme = allSchemes.find(
                (scheme: any) => scheme.scheme_id === selectedIp
            );

            if (selectedInitialScheme?.group_id) {
                const linkedMps = maintenanceOptions.filter((scheme: any) =>
                    selectedInitialScheme.group_id === scheme.group_id &&
                    scheme.value !== selectedIp
                );
                setFilteredMaintenanceOptions(linkedMps);
            } else {
                setFilteredMaintenanceOptions(maintenanceOptions);
            }
        }
    }, [selectedIp, allSchemes, maintenanceOptions]);

    
    const onPatientUpdateStatus = async () => {
        let currentCycleNumber = null;
        let nextCycleNumber = null;
        let selectedInitialScheme = null;

        const isSoliris = child_program_id.includes('soliris');
        const isTruqap = child_program_id.includes('truqap');
        const isCalquence = child_program_id.includes('calquence');

        if (isSoliris) {
             selectedInitialScheme = allSchemes.find(
                (scheme: any) => scheme.scheme_id === selectedIp
            );

            if (selectedInitialScheme && selectedInitialScheme?.cycles?.length) {
                const currentCycle = selectedInitialScheme?.cycles?.[0] || {};
                const nextCycle = selectedInitialScheme?.cycles?.[1] || {};
                currentCycleNumber = currentCycle?.number;
                nextCycleNumber = nextCycle?.number;
            }
        }

        const payload = {
            child_program_id,
            doctor_name: selectedDoctor.full_name,
            doctor_id: selectedDoctor.id,
            hospital: selectedHospital,
        };

        if (isSoliris) {
            Object.assign(payload, {
                initial_scheme: selectedIp,
                maintenance_scheme: selectedMp,
                current_cycle: currentCycleNumber,
                next_cycle: nextCycleNumber,
                transaction_cycles: selectedInitialScheme?.cycles || [],
            });
        } else if (isTruqap) {
            Object.assign(payload, {
                current_cycle: selectedScheme?.cycles?.[0]?.number || null,
                next_cycle: selectedScheme?.cycles?.[1]?.number || null,
                transaction_cycles: selectedScheme?.cycles || [],
            });
        } else if (isCalquence) {
            Object.assign(payload, {
                assigned_tier: selectedTier
            });
        }

       // console.log("payload for approval", payload);
        const res = await approveRejectPatientRegistration({
            id: patient_id,
            program_id,
            action: 'approve',
            payload: payload
        });
       alert(res.message);
        window.location.reload();
    };

    const onClick = async (action: string) => {
        if (window.confirm(`Do you want to ${action} this patient?`)) {
            if (action === "approve") {
                  setOpenConfirmTier(true);
            }
            if (action === "reject") {
                setOpenModal(true);
            }
        }
    };

    const onReject = async () => {
        try {
            const res = await approveRejectPatientRegistration({
                id: patient_id,
                program_id,
                action: 'reject',
                payload: {
                    registration_rejection_notes: rejectionNotes,
                    assigned_tier: selectedTier,
                    child_program_id: child_program_id
                }
            });

            setOpenModal(false);

            setSuccessMessage(res.message);
            setConfirmation(true);

            window.location.reload();
        } catch (err) {
            alert(err.message);
        }
    };

    if (status !== "pre-approval") {
        return <></>;
    }

    const formContent = (
        <>
            <FormControl className={classes.formControl}>
                <FormLabel>
                    <Typography>
                        Rejection Notes
                    </Typography>
                </FormLabel>
                <TextField className={classes.field}
                    required={true}
                    type="text"
                    onChange={(e) => {
                        const { value } = e.target;
                        setRejectionNotes(value);
                    }}
                />
            </FormControl>
        </>
    );

    const handleClose = () => {
        setOpenModal(false);
        setRejectionNotes("");
        setConfirmation(false);
        setOpenConfirmTier(false);
    }

    const onSelectTierUpdate = async () => {
        if(!selectedDoctor?.id) {
            alert("Please select a doctor");
            return;
        }
        if (!selectedHospital || selectedHospital.trim() === "") {
            alert("Please select a hospital");
            return;
        }
        try {
            onPatientUpdateStatus();
        }
        catch (err) {
            alert(err.message);
        }
    };

    const formButtons = (
        <>
            <Button onClick={handleClose} variant='contained'>
                Close
            </Button>
            <Button onClick={onReject} variant='contained' color='secondary'>
                Submit
            </Button>
        </>
    );

    const formTierButtons = (
        <>
            <Button onClick={handleClose} variant='contained'>
                Close
            </Button>
            <Button onClick={onSelectTierUpdate} variant='contained' color='secondary'>
                Submit
            </Button>
        </>
    );

    const confirmationButton = (
        <>
            <Button onClick={handleClose} variant='contained'>
                OK
            </Button>
        </>
    );

    const formTierContent = (
        <>
            <FormControl className={classes.formControl}>
                <FormLabel>
                    <Typography>Select Doctor</Typography>
                </FormLabel>

                <Autocomplete
                    options={hcpList}
                    getOptionLabel={(option) =>
                        option?.full_name || option?.metadata?.hospital || ''
                    }
                    value={selectedDoctor}
                    onChange={(event, newValue) => {
                        setSelectedDoctor(newValue);
                        setSelectedHospital(null); // reset
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Search doctor by name"
                            required
                            className={classes.field}
                        />
                    )}
                />

                <FormLabel>
                    <Typography>Select Hospital</Typography>
                </FormLabel>
                <Autocomplete
                    options={selectedDoctor?.metadata?.hospital || []}
                    getOptionLabel={(option) => option || ''}
                    value={selectedHospital}
                    onChange={(event, newValue) => {
                        setSelectedHospital(newValue);
                    }}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            placeholder="Select hospital"
                            className={classes.field}
                        />
                    )}
                />

                {financial_assessment === 'yes' && child_program_id.includes('calquence') &&
                    <>
                        <FormLabel>
                            <Typography>
                                Select Tier
                            </Typography>
                        </FormLabel>

                        <Select
                            className={classes.field}
                            required={true}
                            value={selectedTier}
                            onChange={(e) => setSelectedTier(e.target.value as string)}
                        >
                            <MenuItem value="tier1">Tier 1</MenuItem>
                            <MenuItem value="tier2">Tier 2</MenuItem>
                        </Select>
                    </>   
                }   

                   {child_program_id.includes('soliris') &&
                    <>
                        <FormLabel>
                            <Typography>
                                Select Initial scheme
                            </Typography>
                        </FormLabel>

                        <Select
                            className={classes.field}
                            required={true}
                            value={selectedIp}
                            onChange={(e) => setSelectedIp(e.target.value as string)}
                        >
                        {initialOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                        </Select>

                        <FormLabel>
                            <Typography>
                                Select Maintenance scheme
                            </Typography>
                        </FormLabel>
                         <Select
                            className={classes.field}
                            required={true}
                            value={selectedMp}
                            onChange={(e) => setSelectedMp(e.target.value as string)}
                        >
                        {filteredMaintenanceOptions.map((option) => (
                            <MenuItem key={option.value} value={option.value}>
                                {option.label}
                            </MenuItem>
                        ))}
                        </Select>
                    </>   
                }               
            </FormControl>
        </>
    );


    return (
        <>
            <Dialog
                key='patient-registation-approval'
                open={openModal}
                title={modalTitle}
                content={formContent}
                children={formButtons}
                onSubmit={onReject}
                onClose={handleClose}
            />
            <Dialog
                key='confirmation'
                open={openConfirmation}
                title='Confirmation'
                content={successMessage}
                children={confirmationButton}
                onSubmit={null}
                onClose={handleClose}
            />
            <Dialog
                key='Assign Tier Confirmation'
                open={openConfirmTier}
                title='Approve Patient'
                content={formTierContent}
                children={formTierButtons}
                onSubmit={null}
                onClose={handleClose}
            />
            <Button color="primary" variant="contained" onClick={() => onClick('approve')} style={{ marginRight: 8 }} >Approve</Button>
            <Button variant="contained" onClick={() => onClick('reject')} style={{ marginRight: 8 }}>Reject</Button>
        </>
    )
}

export default PatientRegistrationApprovalWithTier;
